import React, { useState, useCallback, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';

import { format, parseISO } from 'date-fns';
import { isArray, groupBy, isEmpty } from 'lodash';
import qs from 'querystring';

import { Report, Modal } from '~/components';
import { Shifts, TableMinimizable } from '~/componentslocal';
import { t, number } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';
import Form from './Form';

export default function TransVazAbast() {
  const [open, setOpen] = useState(true);
  const [grid, setGrid] = useState(false);
  const [toolbar, setToolbar] = useState({});
  const [items, setItems] = useState([]);

  const formRef = useRef(null);
  const modalRef = useRef(null);

  const title = useMemo(() => 'Transformar Vazamento em Abastecimento', []);

  const initial = useMemo(
    () => ({
      datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const headerMinimizable = useMemo(
    () => [
      { id: 'post_desc', label: 'Posto' },
      {
        id: 'abas_datahora_ini',
        label: 'Data',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      { id: 'bico_cod_bico', label: 'Bico', align: 'center' },
      { id: 'abas_vol_amb', label: 'Volume Amb.', align: 'right' },
      {
        id: 'abas_encer_ini',
        label: 'Enc. Inicial',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'abas_encer_fim',
        label: 'Enc. Final',
        align: 'right',
        formatted: (value) => number(value, 1),
      },
    ],
    []
  );

  const handleOnClose = useCallback(() => setOpen(false), []);

  const handleCallbackToolbar = useCallback((data) => setToolbar(data), []);

  const handleCallbackMinimizable = useCallback(async (data) => {
    try {
      const response = await api.get(
        '/manutencaocontrole/getmanutencaoagendaexiste',
        {
          params: {
            chave: `(POST_COD_POSTO = &#183${data.post_cod_posto}&#183 AND ABAS_COD_ABAS = ${data.abas_cod_abas})`,
            status: 'P',
            codigoposto: data.post_cod_posto,
            codtarefa: 0,
          },
        }
      );

      if (isEmpty(response.data)) modalRef.current.handleOpenModal({ data });
      else toast.error('Atenção: Já existe uma tarefa agendada em aberto!');
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleGetDetailsAPI = useCallback(async (data) => {
    try {
      const response = await api.get('/manutencaocontrolecancelavazamento', {
        params: data,
        paramsSerializer: (s) => qs.stringify(s),
      });

      setItems(groupBy(response.data.items, 'post_desc'));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleBeforeSending = useCallback(() => {
    const { initial, final, tank } = toolbar;

    const wherefield = ['datahorainicial', 'datahorafinal'];
    const typewherefield = ['MAIOR_IGUAL', 'MENOR_IGUAL'];
    const valuewherefield = [initial, final];

    if (tank) {
      wherefield.push('post_cod_posto');
      typewherefield.push('EQUALS');
      valuewherefield.push(tank);
    }

    setGrid(true);
    handleGetDetailsAPI({
      wherefield,
      typewherefield,
      valuewherefield,
      pagesize: 99999,
    });

    return undefined;
  }, [toolbar]);

  if (!grid)
    return (
      <Report
        open={open}
        onClose={handleOnClose}
        title={title}
        relatorio=""
        serialize={handleBeforeSending}
        initials={initial}
      >
        <Shifts forms={formRef} onToolbar={handleCallbackToolbar} />
      </Report>
    );

  return (
    <S.Wrapper>
      <S.Header>
        <li>
          <span>Data</span> {toolbar.issuance_date}
        </li>
        <li>
          <span>Posto</span> {toolbar.station}
        </li>
        <li>
          <span>Período</span> {toolbar.period}
        </li>
      </S.Header>

      <TableMinimizable
        header={headerMinimizable}
        data={items}
        onCallback={handleCallbackMinimizable}
        maxHeight={22}
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        title={title}
        ref={modalRef}
        component={Form}
        onForm={handleBeforeSending}
        maxWidth="sm"
      />
    </S.Wrapper>
  );
}
